export const PlaceholderImage=()=>{
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 250" width="600" height="250">
            <rect width="600" height="250" fill="#cccccc"></rect>
            <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontFamily="monospace" fontSize="26px" fill="#333333">600x250</text>   
        </svg>
    )
  }
  
  export const ImportIcon=()=>(<svg
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      height="18"
      width="18"
      className="button__icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="none" d="M0 0h24v24H0z" stroke="none"></path>
      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
      <path d="M7 11l5 5l5 -5"></path>
      <path d="M12 4l0 12"></path>
    </svg>
  )
  
  export const ExportIcon=()=>(
    <svg width="14px" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" strokeLinejoin="round" strokeLinecap="round"></path>
    </svg>
  )
  
  export const CloseIcon=({width=20, height=20})=>(
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
      <rect width="100" height="100" fill="none" rx="15" />
      <line x1="30" y1="30" x2="70" y2="70" stroke="white" strokeWidth="10" strokeLinecap="round" />
      <line x1="70" y1="30" x2="30" y2="70" stroke="white" strokeWidth="10" strokeLinecap="round" />
    </svg>
  )
  
  export const EditIcon=()=>(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="edit-icon"
    >
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.121 2.121 0 113 3L8 18l-4 1 1-4 11.5-11.5z"></path>
    </svg>
  )
  
  export const BackButtonIcon=()=>(
    <>
      <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          className="back-icon"
      >
          <path d="M15 4L9 12L15 20" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </>
  )
  
  export const SaveButtonIcon=()=>(
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        className="save-icon"
        width="18"
    >
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
        <polyline points="17 21 17 13 7 13 7 21" />
        <polyline points="7 3 7 8 15 8" />
    </svg>
  )
  
  export const SendEmailIcon=()=>(
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
        className="send-icon"
        width="18"
    >
        <path d="M22 2L11 13" />
        <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  )  

export const AnalyticsIcon=()=>(
  <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 64 64" 
      width="20" 
      height="20" 
      id="analytics">
    <g fill="red">
      <path d="M23 48.5h-3v-15h-6v15h-3v-18h12v18M38 48.5h-3v-24h-6v24h-3v-27h12v27M53 48.5h-3v-33h-6v33h-3v-36h12v36M8 48.5h48v3H8z"></path>
    </g>
  </svg>
)